import React, {
  useEffect,
  useState,
} from 'react';

import { communicationAPI } from 'api/communicationAPI';
import CloseIcon from 'assets/images/icon/CloseIcon';
import Myself from 'assets/images/icon/Myself';
import PlusIconDark from 'assets/images/icon/PlusIconDark';

import StarFill from 'assets/images/icon/Star_fill';
import StarEmpty from 'assets/images/icon/StarEmpty';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { FaUser } from 'react-icons/fa6';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import FileIcon from "../../../../assets/images/icon/FileIcon";
import UploadIcon from "../../../../assets/images/icon/UploadIcon";
import FileInputIcon from "../../../../assets/images/icon/FileInputIcon";
import Advise from "../../../../assets/images/icon/Advice";
import Information from "../../../../assets/images/icon/Informaiton";
import Talk from "../../../../assets/images/icon/Talk";
import OtherSolution from "../../../../assets/images/icon/OtherSolution";
import {useRecoilState} from "recoil";
import {RequestedData} from "../../../../state";
import {textTransform} from "../../../../util";
import FileRemoveIcon from "../../../../assets/images/icon/FileRemoveIcon";
import DeleteRedIcon from "../../../../assets/images/icon/DeleteRedIcon";
import {coachingAPI} from "../../../../api/coachingAPI";
import axios from "axios";
import VideoIcon from "../../../../assets/images/icon/VideoIcon";
import ClassicIcon from "../../../../assets/images/icon/ClassicIcon";
import {commonAPI} from "../../../../api/commonAPI";
import {Overlay} from "../../../components";
import {VideoPlayerComponent} from "../../../components/common/VideoPlayerComponent";
import {usePlayJwp} from "../../../../hooks/usePlayJwp";
import TestPage from "../../Test/TestPage";
import ReactPlayer from "react-player";
import SomeoneElse from "../../../../assets/images/icon/SomeoneElse";

const arr = [1, 2, 3, 4, 5];
const category = [
    {
        title:"Myself",
        icon:<Myself/>,
        value:"MYSELF"
    },
    {
        title:"Someone else",
        icon:<SomeoneElse />,
        value:"SOMEONE_ELSE"
    },
]
const solutionType = [
    {
        title:"Advice",
        icon:<Advise/>,
        value:"ADVICE"
    },
    {
        title:"Information",
        icon:<Information />,
        value:"INFORMATION"
    },
    {
        title:"Pep Talk",
        icon:<Talk/>,
        value:"PEP_TALK"
    },
    {
        title:"Other",
        icon:<OtherSolution />,
        value:"OTHER"
    },
]
const RequestPopup = (props) => {

    const [reqData, setReqData] = useState(null);
    const [userType, setUserType] = useState("He/Him");
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [jwpSpec, setJwpSpec] = useState(null);
    const [videoId, setVideoId] = useState(null);
    const { status, view} = usePlayJwp(!isEmpty(props?.data?.videoCoaching?.videoReply) ? {
        id:videoId
    } : null)

    const returnData = (date) => {
        const c = cloneDeep(date)?.map((item, index) => {
            if (index === 1) {
                item = item - 1;
            }
            return item;
        });
        let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
            .utc()
            .locale("en")
            .format("MMM DD, YYYY");
        return date;
    };

    const getCategoryEvent = (category) => {
        switch (category) {
            case "Myself" : {
                return {
                    event:()=>{

                    }
                }
            }

            case "Someone else" : {
                return
            }

            default:
                break;
        }
    }

    const getFormData = () => {
        const formData = new FormData();
        formData.append("requestCoachingReply",JSON.stringify({
            accept:reqData?.accept,
            message:reqData?.message
        }))
        if(uploadFile?.name !== undefined){
            console.log("this")
            const fileBlob = new Blob([uploadFile], {
                type: uploadFile?.type,
            });
            formData.append("file", fileBlob, uploadFile?.name);
        }
        return formData;
    };
    console.log("u", uploadFile?.name);
    console.log("@props?.data?.contentType?.contentType",props?.data?.contentType);

    const putRequest = async () => {
        if(props?.data?.contentType === "VIDEO"){
            await postReqVideo();
        }else{
            await coachingAPI
                .postRequestClassic(props?.data?.id, {
                    data:getFormData(),
                })
                .then((res) => {
                    console.log("suc", res);
                    props.onClickPopup();
                });
        }
    };

    const deleteVideo = async () => {
        setJwpSpec(null);
    }
    const getFormVideoData = () => {
        const formData = new FormData();
        // formData.append()
    }
    const postReqVideo = async () => {
        let pData:any;

        if(!isEmpty(jwpSpec)){
            pData = {
                accept:reqData?.accept,
                message:reqData?.message,
                jwPlayerId:jwpSpec.jwPlayerId,
                title:jwpSpec.title,
                fileName:jwpSpec.fileName
            }
        }else{
            pData = {
                accept:reqData?.accept,
                message:reqData?.message,
            }
        }
        setUploadLoading(true)
        try {
            await coachingAPI.postRequestVideo(props?.data?.id, {
                data:pData
            })
                .then((res) => {
                    console.log("suc", res);
                    props.onClickPopup();
                });
        }catch (e) {
            setUploadLoading(false)
            alert("Fail")
        }finally {
            setUploadLoading(false)
        }
    }
    const handleDownload = () => {
        // Create a link element
        const link = document.createElement("a");
        link.href = props?.data?.videoCoaching?.requestFile?.url;
        link.target = '_blank';
        link.download = props?.data?.file?.fileName;
        // Simulate a click on the link to trigger the download
        link.click();
    };

    const handleLocalDownload = (file) => {
        if (file) {
            const downloadLink = URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = downloadLink;
            a.download = file.name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    const handleUploadJWP = async (e) => {
        const file = e.target.files[0];
        console.log("file", file);

        if (!file) {
            return;
        }
        try {
            const videoElement = document.createElement('video');
            videoElement.preload = 'metadata';
            videoElement.src = URL.createObjectURL(file);

            await new Promise(resolve => {
                videoElement.onloadedmetadata = () => {
                    //@ts-ignore
                    resolve();
                };
            });
            const duration = videoElement.duration;
            setUploadLoading(true)
            console.log("@duration",duration);
            const result = await commonAPI.postVideoMetadata({
                data: {
                    metadata: {
                        title: file?.name,
                        duration: Number(duration.toFixed(0)),
                    },
                    upload: {
                        mimeType: file?.type,
                    },
                    fileName: file?.name,
                    preview: true,
                    drm: false
                },
            });
            if (result) {
                const uploadLink = result.data.upload_link;

                const fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = async () => {
                    const arrayBuffer = fileReader.result as ArrayBuffer;
                    const uint8Array = new Uint8Array(arrayBuffer);
                    const buffer = uint8Array.slice();
                    axios({
                        method: "PUT",
                        url: uploadLink,
                        headers: {
                            "Content-Type": file?.type,
                        },
                        data: new Blob([buffer]),

                        // onUploadProgress: (progressEvent) => {
                        //     const percentage =
                        //         (progressEvent.loaded / (progressEvent.total || 1)) * 100;
                        //     const percentCompleted = Math.round(percentage);
                        //     setPercentage(percentCompleted);
                        // },
                    }).then((res) => {
                        console.log("video", res);
                        // setSyllabusTitle(file?.name);
                        setJwpSpec({
                            jwPlayerId:result.data.jwPlayerId,
                            title:file?.name,
                            fileName:file?.name
                        })
                        setUploadLoading(false);
                    });
                };
            }
        } catch (error) {
            console.log("error", error);
        }finally {

            e.target.value = ""
        }
    };


    const updateReqData = (column, value) => {
        const c = cloneDeep(reqData);
        c[column] = value;
        setReqData(cloneDeep(c));
    }

    useEffect(() => {
        setReqData(
            {
            ...cloneDeep(props?.data),
            accept:props?.data?.coachingStatus == "REJECTED" ? false : true
            }
        )
    }, []);

    useEffect(()=>{
        if(props?.data?.fileReply?.fileName === "blob"){
            setUploadFile(null)
        }else{
            setUploadFile(cloneDeep(props?.data?.fileReply))
        }
    },[]);

    useEffect(()=>{
        if(!isEmpty(props?.data?.videoCoaching?.videoReply)){
            setJwpSpec(props?.data?.videoCoaching?.videoReply);
        }
    },[]);

    useEffect(()=>{
        document.addEventListener("keydown",(e)=>{
            if(e.keyCode === 27){
                setVideoId(null)
            }
        })
    },[])

    console.log("props?.data", props?.data);
    console.log("reqData", reqData)
    console.log("@jwpSpec",jwpSpec);
    console.log("@status",status);
    function calculateHeightFor16x9(width) {
        const aspectRatio = 9 / 16; // 세로 비율 / 가로 비율
        const height = width * aspectRatio;
        return height;
    }
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
    const [upload, setUpload] = useState(null);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            // 파일에 대한 URL 생성
            const fileUrl = window.URL.createObjectURL(file);
            setUploadedFileUrl(fileUrl);
        }
    };
    console.log("@videoId",videoId);
    console.log("@localUrl",uploadedFileUrl);
    console.log("@props?.data",props?.data);
    console.log("@gender",props?.data?.videoCoaching?.gender);

    return (
        <Container>
            {
                videoId !== null && status === 'ready' &&
                <VideoPlayerComponent filter={true} width={800} onClickClose={()=>{setVideoId(null)}}>
                    {
                      status === 'ready' ?
                            <div id={"jwplayer"}
                                 // style={{borderRadius:8, width:"90%", height:calculateHeightFor16x9(800)}}
                            />
                            :
                            <div></div>
                    }
                </VideoPlayerComponent>
            }
            {
                upload !== null &&
                <VideoPlayerComponent filter={true} width={800} onClickClose={()=>{setUpload(null)}}>
                    <ReactPlayer
                        width={800}
                        url={upload}
                        controls={true}
                        height={calculateHeightFor16x9(800)}
                        loop={true}
                        playing={true}
                    />
                </VideoPlayerComponent>
            }
            {
                uploadLoading &&
                <Overlay filter={false}>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <rect x="15" y="30" width="10" height="40" fill="#ddc160">
                            <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                     keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                     begin="-0.6"/>
                        </rect>
                        <rect x="35" y="30" width="10" height="40" fill="#ddc160">
                            <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                     keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                     begin="-0.4"/>
                        </rect>
                        <rect x="55" y="30" width="10" height="40" fill="#ddc160">
                            <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                     keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                     begin="-0.2"/>
                        </rect>
                        <rect x="75" y="30" width="10" height="40" fill="#ddc160">
                            <animate attributeName="opacity" dur="1s" repeatCount="indefinite" calcMode="spline"
                                     keyTimes="0;0.5;1" keySplines="0.5 0 0.5 1;0.5 0 0.5 1" values="1;0.2;1"
                                     begin="-1"/>
                        </rect>
                    </svg>
                </Overlay>
            }
            <Title>
                <PopupHeader>
                    <h1>{props?.data?.videoCoaching?.title || "Coaching Request"}</h1>
                    <Avatar>
                        {!isEmpty(props?.data?.teacherThumbnailUrl) ? (
                            <img
                                src={
                                    props?.data?.teacherThumbnailUrl ||
                                    "/images/userFeedback.png"
                                }
                                alt=""
                            />
                        ) : (
                            <FaUser className={"user"}/>
                        )}
                        <span>{props?.data?.teacherName || "Instructor"}</span>
                        <DateItem
                            className={props?.data?.contentType !== "CLASSIC" ? "video" : "classic"}
                            style={{background: "none", border: "none", marginLeft: 10}}>
                            {
                                props?.data?.contentType !== "CLASSIC"
                                    ? <VideoIcon/> : <ClassicIcon/>
                            }
                            <span style={{marginLeft: 5}}>
                        {textTransform().capitalizeFirstLetter(String(props?.data?.contentType)?.toLocaleLowerCase())}
                          </span>
                        </DateItem>
                    </Avatar>
                    <Close
                        onClick={() => {
                            props?.onClickPopup();
                        }}
                    >
                        <CloseIcon/>
                    </Close>
                </PopupHeader>

            </Title>
            <ContentsWrap>
                <Contents>
                    <p>
                        1. Who is this Whoflex Coaching for?
                    </p>
                    <Category>
                        {
                            category.map((item, index) => {
                                return (
                                    <div
                                        style={{marginRight: 50}}
                                        className={reqData?.videoCoaching?.target === item?.value ? "on" : ""}
                                        onClick={() => {
                                            // updateReqData("target",item?.value)
                                        }}
                                    >
                                        <SvgWrap>
                                            {item.icon}
                                        </SvgWrap>

                                        <span>
                                    {item.title}
                                </span>
                                    </div>
                                )
                            })
                        }
                    </Category>

                    <InputItem>
                        <h4>To (First name)</h4>
                        <input value={reqData?.videoCoaching?.toName} readOnly={true} placeholder={""} type={"text"}/>
                        <UserType>
                            {
                                [
                                    {
                                        type:"HE_HIM",
                                        name:"He/Him"
                                    },
                                    {
                                        type:"SHE_HER",
                                        name:"She/Her"
                                    },
                                    {
                                        type:"THEY_THEM",
                                        name:"They/Them"
                                    }
                                ].map(item => {
                                    return (
                                        <span
                                            onClick={() => {
                                                // setUserType(item)
                                            }}
                                            className={props?.data?.videoCoaching?.gender === item?.type ? "on" : ""}>
                                        {item?.name}
                                    </span>
                                    )
                                })
                            }
                        </UserType>
                    </InputItem>

                    <SubTile>2.What type of solutions?</SubTile>
                    <Category>
                        {
                            solutionType.map((item, index) => {
                                return (
                                    <div
                                        style={{marginRight: 50}}
                                        className={reqData?.videoCoaching?.solutionType === item?.value ? "on" : ""}
                                        onClick={() => {
                                            // updateReqData("solutionType",item?.value)
                                        }}
                                    >
                                        <SvgWrap>
                                            {item.icon}
                                        </SvgWrap>

                                        <span>
                                    {item.title}
                                </span>
                                    </div>
                                )
                            })
                        }
                    </Category>
                    <Rating>
                        <SubTitle>3. Write details about your request.</SubTitle>
                        <textarea
                            placeholder={"What issue do you need advice on?\nPlease describe the current situation or any challenges.\nWhat do you want [Instructor] to know about your request for advice?"}
                            readOnly={true}
                            value={props?.data?.videoCoaching?.request}
                            onChange={(e) => {
                                updateReqData("request", e.target.value)
                            }}
                        />
                    </Rating>
                    <p style={{marginTop: 20, marginBottom: 15}}>
                        Please add attachment here
                    </p>
                    <InputContents>
                        <InputIcons
                            onClick={
                                () => {
                                    if (isEmpty(props?.data?.videoCoaching?.requestFile?.fileName)) return;
                                    handleDownload()
                                }
                            }
                        >
                            <FileInputIcon/>
                            <p>{props?.data?.videoCoaching?.requestFile?.fileName ?? "-"}</p>
                        </InputIcons>
                    </InputContents>
                </Contents>

                <Contents style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                }}>
                    <SubTile style={{marginBottom: 14}}>Your Answer
                        <DateItem style={{background: "none", border: "none", marginLeft: 10}}>
                            {
                                props?.data?.contentType !== "CLASSIC"
                                    ? <VideoIcon/> : <ClassicIcon/>
                            }
                            <span style={{marginLeft: 5}}>
                        {textTransform().capitalizeFirstLetter(String(props?.data?.contentType)?.toLocaleLowerCase())}
                          </span>
                        </DateItem>
                    </SubTile>
                    <Radio>
                        <RadioButton
                            onClick={() => {
                                updateReqData("accept", true)
                            }}
                            className={reqData?.accept === true ? "on" : ""}
                        >
                            <div className="circle"></div>
                            <span>
                                Accept
                            </span>
                        </RadioButton>
                        <RadioButton
                            onClick={() => {
                                updateReqData("accept", false)
                            }}
                            className={reqData?.accept === false ? "on" : ""}>
                            <div className="circle"></div>
                            <span>
                                Decline
                            </span>
                        </RadioButton>
                    </Radio>
                    <Rating style={{height: "100%", paddingBottom: 20}}>
                        <textarea
                            style={{
                                height: "100%"
                            }}
                            // readOnly={reqData?.coachingStatus === "COMPLETED" || reqData?.coachingStatus === "REJECTED"}
                            value={reqData?.message}
                            onChange={(e) => {
                                updateReqData("message", e.target.value)
                            }}
                        />
                    </Rating>

                    {
                        props?.data?.coachingStatus !== "REJECTED" && props?.data?.coachingStatus !== "COMPLETED" &&
                        <>
                            <p style={{marginTop: 20, marginBottom: 15}}>
                                Please add attachment here
                            </p>
                            <InputContents
                                style={{display: props?.data?.contentType !== "CLASSIC" ? "none" : "block"}}>
                                <InputIcons
                                    onClick={(e) => {
                                        if (!isEmpty(uploadFile?.name)) {
                                            handleLocalDownload(uploadFile);
                                        }
                                        if (uploadFile && !isEmpty(uploadFile.fileName) && uploadFile.url) {
                                            const a = document.createElement('a');
                                            a.href = uploadFile.url;
                                            a.download = uploadFile.fileName;
                                            document.body.appendChild(a);
                                            a.click();
                                            document.body.removeChild(a);

                                            // fetch(uploadFile.url)
                                            //     .then((response) => response.blob())
                                            //     .then((blob) => {
                                            //         const url = window.URL.createObjectURL(blob);
                                            //         const a = document.createElement('a');
                                            //         a.href = url;
                                            //         a.download = uploadFile.fileName;
                                            //
                                            //         document.body.appendChild(a);
                                            //         a.click();
                                            //
                                            //         window.URL.revokeObjectURL(url);
                                            //         document.body.removeChild(a);
                                            //     })
                                            //     .catch((error) => {
                                            //         console.error('Error downloading file: ', error);
                                            //     });
                                        }
                                    }}
                                >
                                    {
                                        isEmpty(uploadFile?.name) && isEmpty(uploadFile?.fileName) ? <FileInputIcon/> :
                                            <div
                                                className={"remove"}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setUploadFile(null)
                                                }}>
                                                <DeleteRedIcon/>
                                            </div>
                                    }
                                    <p>{(uploadFile?.name || uploadFile?.fileName) ?? "Add file or drop file here"} </p>
                                    <input
                                        style={{
                                            display: !(isEmpty(uploadFile?.name) && isEmpty(uploadFile?.fileName)) ? "none" : "block",
                                            width: "100%", height: "100%"
                                        }}
                                        type={"file"} onChange={(e) => {
                                        setUploadFile(e.target.files[0])
                                        e.target.value = ""
                                    }}/>
                                </InputIcons>

                            </InputContents>
                            <InputContents
                                style={{display: props?.data?.contentType !== "VIDEO" ? "none" : "block"}}>
                                <InputIcons
                                    onClick={(e) => {
                                        if (!isEmpty(props?.data?.videoCoaching?.videoReply)) {
                                            // jwpDownload
                                            setVideoId(props?.data?.videoCoaching?.videoReply?.id)
                                        } else {
                                            setUpload(uploadedFileUrl)
                                        }
                                    }}
                                >
                                    {
                                        isEmpty(jwpSpec?.fileName) ? <FileInputIcon/> :
                                            <div
                                                className={"remove"}
                                                onClick={async (e) => {
                                                    e.stopPropagation();
                                                    await deleteVideo();
                                                    setUploadedFileUrl(null);
                                                }}>
                                                <DeleteRedIcon/>
                                            </div>
                                    }
                                    <p>{jwpSpec?.fileName ?? "Add file or drop file here"} </p>
                                    <input
                                        style={{
                                            display: !isEmpty(jwpSpec?.fileName) ? "none" : "block",
                                            width: "100%", height: "100%"
                                        }}
                                        type={"file"} onChange={async (e) => {
                                        handleFileChange(e);
                                        await handleUploadJWP(e);
                                        e.target.value = ""
                                    }}/>
                                </InputIcons>
                            </InputContents>
                        </>
                    }

                    {props?.data?.coachingStatus !== "REJECTED" && props?.data?.coachingStatus !== "COMPLETED" && (
                        <Send>
                    <span
                        onClick={() => {
                            putRequest()
                        }}
                    >
                        Send
                    </span>
                        </Send>
                    )}
                    {/*<Send>*/}
                    {/*<span*/}
                    {/*    onClick={() => {*/}
                    {/*        putRequest()*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Send*/}
                    {/*</span>*/}
                    {/*</Send>*/}
                </Contents>
            </ContentsWrap>
            {/*<CloseButton*/}
            {/*    onClick={() => {*/}
            {/*        props.onClickPopup();*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <CloseIcon />*/}
            {/*</CloseButton>*/}
        </Container>
    );
};
export default RequestPopup;

const Container = styled.div`
    width: 78%;
    max-width: 1000px;
    min-width: 900px;
    //overflow: hidden;
    background: #fff;
    border-radius: 8px;
    position: relative;
    h1 {
        font-size: 28px;
        font-weight: 700;
    }
    @media screen and (max-width: 961px) {
        flex-direction: column;
        min-width: 90%!important;
        max-width: 90%!important;
        width: 90% !important;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
        @supports (-webkit-touch-callout: none) {
            /* Safari 스타일 */
            top:48%
        }
    }
    @media screen and (max-width: 768px) {
        flex-direction: column;
        min-width: 90%!important;
        max-width: 90%!important;
        width: 90% !important;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 85%;
        overflow-y: auto;
        @supports (-webkit-touch-callout: none) {
            /* Safari 스타일 */
            top:42%;
            height: 80%;
        }
    }
`;

const Title = styled.div`
    padding: 23px 20px 20px 20px;
    position: relative;
`;
const Close = styled.div`
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 9;
    svg{
        width: 30px;
        height: 30px;
    }
`
const ContentsWrap = styled.div`
   display: flex;
    width: 100%;
    max-height: 600px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        
    }
`

const PopupHeader = styled.div`
    padding: 19px 0 18px 0;
    position: relative;
    background: #333;
    border-radius: 15px;
    color: #fff;
    h1{
        font-family: Europa-Bold;
        font-size: 24px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0em;
        text-align: left;
        margin-bottom: 10px;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
const SubTitle = styled.div`
    font-family: Europa-Bold;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
`;

const Contents = styled.div`
    margin-top: 10px;
    padding: 0 20px 10px 20px;
    width: 50%;
    height: 500px;
    overflow: auto;
    @media screen and (max-width: 768px) {
        width: 100%;
        height: 100%!important;
        overflow: visible;
    }
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;
const Category = styled.div`
    margin-top: 15px;
    margin-bottom: 20px;
    display: flex;
    & > div {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        svg{
            width: 24px;
            height: 24px;
        }
    }
    @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        display: flex;
        flex-direction: row!important;
        & > div{
            margin-right: 0!important;
            width: 50%;
            margin-top: 5px;
            span{
                align-items: flex-start;
            }
        }
    }
`;
const SvgWrap = styled.div`
    width: 42px;
    height: 42px;
    border: solid 1px #333333;
    border-radius: 50%;
    display: flex; 
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    transition: all 0.2s;
    
    path{
        opacity: 0.6;
        fill: #333;
    }
    //&.on{
    //    border-color: #DDC160;
    //}
    .on &{
        border-color: #DDC160;
        path{
            fill: #DDC160;
            opacity: 1;
        }
    }
`
const InputItem = styled.div`
    margin-bottom: 20px;
   input{
       &::placeholder{
           color: #3333334D;
       }
       padding: 14px 19px;
       margin-top: 10px;
       margin-bottom: 10px;
       width: 100%;
       height: 48px;
       border: solid 1px #3333334D; 
       border-radius: 8px;
       outline: none;
   }
`
const UserType = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    span{
        cursor: pointer;
        display: flex;
        margin-top: 5px;
        padding: 12px 15px 8px;
        border: solid 1px #333;
        border-radius: 6px;
        margin-right: 15px;
        opacity: 0.7;
        
        &.on{
            border: solid 1px #DDC160;
            color: #DDC160;
            opacity: 1;
        }
    }
`

const Avatar = styled.div`
    align-items: center;
    margin-right: 15px;
    display: flex;
    svg {
        border-radius: 50%;
        width: 36px;
        height: 36px;
        background: #ddd;
        path {
            fill: #eee;
        }
    }
    img {
        width: 36px;
        height: 36px;
        border-radius: 100%;
        object-fit: contain;
        min-width: 36px;
        min-height: 36px;
    }
    span {
        font-family: Europa-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        margin-left: 15px;
    }
    .video{
        svg{
            border-radius: 0;
        }
    }
`;
const DateItem = styled.div`
    display: flex;
    align-items: center;
    vertical-align: center;
    p {
        color: #33333385;
        margin-right: 10px;
        line-height: 14px;
    }
    &.video{
        svg{
            background: #333;
            stroke: #fff;
            path{
                fill: #fff;
            }
        }
    }
    &.classic{
        svg{
            background: #333;
            stroke: #fff;
            border-radius: 0;
            path{
                fill: #fff;
            }
        }
    }
    svg{
        width: 14px;
        height: 14px;
        stroke: #333;
        stroke-width: 0.5px;
        margin-bottom: 2px;
    }
    span {
        display: flex;
        align-items: center;
        font-family: Europa-Regular;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0em;
        text-align: left;
       
    }
`;

const TextArea = styled.div`
    flex: 1;
    background: #f5f5f5;
    border-radius: 15px;
    h2 {
        line-height: 29px;
        padding: 10px 15px;
        font-size: 22px;
        font-weight: 700;
    }
`;
const CloseButton = styled.div`
    background: #333;
    position: absolute;
    width: 90px;
    cursor: pointer;
    right: 0;
    top: 0;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
        width: 30px;
        height: 30px;
    }
`;
const TextAreaContents = styled.div`
    display: flex;
    padding: 15px;
`;
const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 125px;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
    span {
        font-size: 22px;
        font-weight: 600;
        line-height: 27.5px;
    }
    p {
        line-height: 28px;
        font-size: 18px;
        font-weight: 400;
    }
    b {
        opacity: 0.6;
        font-size: 14px;
        display: inline-block;
        margin-bottom: 4px;
    }
`;
const Radio = styled.div`
   display: flex;
    align-items: center;
`
const RadioButton = styled.div`
    display: flex;
    align-items: center;
    transition: all 0.3s;
    margin-right: 57px;
    cursor: pointer;
   .circle{
       transition: all 0.3s;
       width: 20px;
       height: 20px;
       border-radius: 100px;
       border:solid 1px #33333326;
       .on&{
           border:solid 5px #DDC160;
       }
   }
   span{
       margin-left: 10px;
       font-family: Europa-Bold;
       font-size: 20px;
       font-weight: 700;
       line-height: 30px;
       letter-spacing: 0em;
       text-align: left;
   }
`
const Rating = styled.div`
    h4 {
        font-size: 22px;
        margin-bottom: 15px;
    }
    textarea {
        margin-top: 15px;
        background: #fff;
        border: solid 1px #33333330;
        border-radius: 8px;
        width: 100%;
        height: 110px;
        outline: none;
        resize: none;
        padding: 15px;
        font-size: 16px;
        line-height: 20px;
        &::placeholder{
            font-family: Europa-Regular;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
            letter-spacing: 0em;
            text-align: left;
            color: #333;
            opacity: 0.6;
        }

        scrollbar-width: thin;
        scrollbar-color: #33333320 transparent;
        &::-webkit-scrollbar {
            width: 3px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(51, 51, 51, 0.3);
            border: none;
            border-radius: 4px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
            border: none;
        }
    }
`;
const RatingHeader = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    h2 {
        font-size: 22px;
        margin-right: 30px;
    }
    span {
        b {
            width: 12px;
            font-weight: 400;
        }
        display: flex;
        height: 100%;
        padding-top: 3px;
        width: 54px;
    }
`;
const Stars = styled.div`
    display: flex;
    align-items: center;
`;
const Star = styled.div`
    display: flex;
    align-items: center;
    margin-right: 12px;
    cursor: pointer;
`;
const Send = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 30px;
    font-size: 18px;
    background: #fff;
    span {
        cursor: pointer;
        background: #ddc160;
        color: #fff;
        width: 100%;
        padding: 18px 116px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        border-radius: 44px;
    }
`;
const InputIcons = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
    margin-bottom: 11px;
    padding: 0 20px;
    border-radius: 10px;
    .remove{
        height: 100%;
        padding: 0 5px;
        z-index: 99;
    }
    &.on {
        background-color: #eff3fe;
        border: 2px solid #276ef1;
    }
    & > div {
        display: flex;
        align-items: center;
        .remove_svg_icon {
        }
        svg {
            &:nth-child(1) {
            }
        }
    }
    p {
        margin-left: 18px;
        font-size: 16px;
        font-weight: 700;
        color: #e0c463;
    }
    span {
        font-weight: 400;
        font-size: 17px;
        line-height: 21px;
        color: #111;
    }
`;
const SubTile = styled.h2`
    font-family: Europa-Bold;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    align-items: center;
    span{
        font-family: Europa-Regular;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0em;
        text-align: left;
    }
`
const InputContents = styled.div`
    cursor: pointer;
    position: relative;
    height: 50px;
    width: 100%;
    background: #fff;
    border: 1px solid #ddd;
    color: #e0c463;
    border-radius: 10px;
    input {
        cursor: pointer;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        z-index: 9;
        opacity: 0;
    }
`;

const AnswerArea = styled.div`
   
`
